<template>
  <div class="content-page">
    <div class="container">
      <!-- <InfoBlock /> -->
      <Nav v-if="$route.name !== 'result'" />

      <transition mode="out-in" name="fade">
        <router-view :key="$route.path"/>
      </transition>
    </div>
  </div>
</template>

<script>
  // import InfoBlock from '@/components/pdd/InfoBlock.vue';

  export default {
    components: {
      Nav: () => import('./Nav.vue'),
      // InfoBlock,
    },
  };
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>
